import React from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";

import BasePage from "./view/app";
import AuthPage from "./view/auth";
import { APP_NAME, /* IS_APP_PRODUCTION */ } from "./constants/app";
import { useAuth } from "./plugins/CookieAuthPlugin";

export default function Routes() {
	const { user } = useAuth();
	return (
		<BrowserRouter basename={/* IS_APP_PRODUCTION ? `/` :  */APP_NAME}>
			<Switch>
				{user ? <Redirect from="/login" to="/" /> : <AuthPage />}

				{user ? <BasePage /> : <Redirect to="/login" />}
			</Switch>
		</BrowserRouter>
	);
}
